// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1kRg2","boxTitle":"Qualiphy_boxTitle__25I_Y","box":"Qualiphy_box__gt91y","toggleWrap":"Qualiphy_toggleWrap__11MT3"};